export default __webpack_public_path__ + "static/media/back.e7f0659d.svg";